<template>
  <div v-if="contentType" class="headline-icons" :class="[size && size !== 'default' ? `headline-icons--${size}` : '']">
    <client-only>
      <div v-if="definedLabels.length > 0" class="headline-icons__wrapper--absolute align-items-top">
        <div
          v-for="(definedLabel, index) in definedLabels"
          :key="`flex-icon-${index}`"
          class="headline-icons__icon"
          :class="getLabelClassModifier(definedLabel)"
          :style="definedLabel.bgColor ? { 'background-color': definedLabel.bgColor } : undefined"
        >
          <span v-if="definedLabel.text" :style="definedLabel.textColor ? { color: definedLabel.textColor } : undefined">{{ definedLabel.text }}</span>
          <img v-if="definedLabel.image" :src="definedLabel.image" :style="definedLabel.imageWidth ? { width: definedLabel.imageWidth } : undefined" />
          <div v-if="definedLabel.html" v-html="definedLabel.html"></div>
        </div>
      </div>
    </client-only>
    <div v-if="flexIcons.length" class="headline-icons__wrapper display-flex flex-wrap align-items-top">
      <div v-for="(name, index) in flexIcons" :key="`flex-icon-${index}`" class="headline-icons__icon" :class="getClassModifier(name)">
        <template v-if="name === 'detectorCategory'">
          <i v-if="isPrimaryCategory(85827865) || isPrimaryCategory(79451385)" class="fas fa-ban"></i>
          <i v-else-if="isPrimaryCategory(79451419) || isPrimaryCategory(85827867)" class="fas fa-thumbs-down"></i>
          <i v-else-if="isPrimaryCategory(79451335) || isPrimaryCategory(85827871)" class="fas fa-thumbs-up"></i>
          <i v-else-if="isPrimaryCategory(88121525) || isPrimaryCategory(88122145)" class="fas fa-sliders-v"></i>
          <i v-else-if="isPrimaryCategory(92718855) || isPrimaryCategory(92719795)" class="fas fa-times-circle"></i>
          <i v-else-if="isPrimaryCategory(93953369) || isPrimaryCategory(93953457)" class="fas fa-bullseye-pointer"></i>
          <i v-else-if="isPrimaryCategory(93481599) || isPrimaryCategory(92782775)" class="fas fa-star"></i>
          <i v-else-if="isPrimaryCategory(96049257)" class="fas fa-circle-play"></i>
          <span>{{ headline.primaryCategory.name }}</span>
        </template>
        <template v-else-if="name === 'economist'">
          <img src="https://g.delfi.lt/misc/portal-root/icons/the-economist.svg" width="92" style="width: 92px" alt="The Economist" />
        </template>
        <template v-else-if="name === 'invest'">
          <img src="https://g.delfi.lt/misc/portal-root/icons/investuok.svg" width="100" style="width: 100px" alt="Žurnalas Investuok" />
        </template>
        <template v-else-if="name === 'projectSyndicate'">
          <img src="https://g.delfi.lt/misc/portal-root/icons/project-syndicate.svg" width="35" style="width: 35px" alt="Project Syndicate" />
        </template>
        <template v-else-if="name === 'graph'">
          <i class="fas fa-chart-bar"></i>
        </template>
        <template v-else-if="name === 'paid'">
          <i v-html="require(`!!html-loader!@root/assets/svg/icons/crown.svg`)" />
        </template>
        <template v-else-if="name === 'liveBlog'">
          <i class="fas fa-signal-stream"></i>
        </template>
        <template v-else-if="iconList[name]">
          <BaseIcon :name="iconList[name]" />
        </template>
      </div>
    </div>
    <div v-if="absoluteIcons.length" class="headline-icons__wrapper--absolute">
      <div v-for="(name, index) in absoluteIcons" :key="`absolute-icon-${index}`" class="headline-icons__icon" :class="getClassModifier(name)">
        <template v-if="name === 'awkwardQuestions'">
          <span>Nepatogūs klausimai</span>
        </template>
        <template v-else-if="name === 'breakingNews'">
          <span>Svarbi žinia</span>
        </template>
        <template v-else-if="name === 'career'">
          <span v-if="hasTagId(89580921) || hasIcon('frontPageMostPopularJobOffers')">Populiariausi darbo pasiūlymai</span>
          <span v-else-if="hasTagId(89580923) || hasIcon('frontPageLookingForTalents')">Ieško darbuotojų</span>
          <span v-else-if="hasTagId(89580941) || hasIcon('frontPageInterviewWithCLevelManagers')">Interviu su vadovu</span>
          <span v-else-if="hasTagId(89580979) || hasIcon('frontPageRelevantInTheOffice')">Šiandien biure</span>
          <span v-else-if="hasTagId(89580981) || hasIcon('frontPageItsInteresting')">Tai įdomu!</span>
          <span v-else-if="hasTagId(89969303) || hasIcon('frontPageHHRPerspective')">HR žvilgsnis</span>
        </template>
        <template v-else-if="name === 'detector'">
          <span>{{ headline.primaryCategory.parentCategory.name }}</span>
        </template>
        <template v-else-if="name === 'everydayHeroes'">
          <span>Kasdienybės herojai</span>
        </template>
        <template v-else-if="name === 'exclusive'">
          <span>Išskirtinė Delfi medžiaga</span>
        </template>
        <template v-else-if="name === 'important'">
          <span>Svarbu</span>
        </template>
        <template v-else-if="name === 'interview'">
          <span>Delfi Interviu</span>
        </template>
        <template v-else-if="name === 'premiere'">
          <span>Išankstinė premjera</span>
        </template>
        <template v-else-if="name === 'reminds'">
          <span>Delfi primena</span>
        </template>
        <template v-else-if="name === 'renew'">
          <span>Atnaujinta</span>
        </template>
        <template v-else-if="name === 'research'">
          <span>Delfi tyrimas</span>
        </template>
        <template v-else-if="name === 'specialProject'">
          <span>Specialus projektas</span>
        </template>
        <template v-else-if="name === 'stream'">
          <i />
          <span>Tiesioginė transliacija</span>
        </template>
        <template v-else-if="name === 'streamDvr'">
          <i />
          <span>Transliacija</span>
        </template>
        <template v-else-if="name === 'streamSoon'">
          <i />
          <span>Netrukus transliuosime</span>
        </template>
        <template v-else-if="name === 'test'">
          <span>Testas</span>
        </template>
        <template v-else-if="name === 'sauguComment'">
          <span>Ekspertai paaiškina</span>
        </template>
        <template v-else-if="name === 'regionNews'">
          <span>Žinios iš regionų</span>
        </template>
        <template v-else-if="name === 'dakaras'">
          <span>Dakaras 2025</span>
        </template>
        <template v-else-if="name === 'weekReview'">
          <span>Delfi savaitės apžvalga</span>
        </template>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import BaseIcon from '@core/components/UI/BaseIcon.vue';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';
import { gridConfig } from '@core/config/grid.config';
import { iconsConfig, iconList, careerIcons, careerTags, detectorCategories } from '@headlines/config/icons.config';
import { getDefinedLabels } from '@headlines/utils/getDefinedLabels';
import { Label } from '@root/modules/channel/types/channel';

import dayjs from 'dayjs';
import 'dayjs/locale/lt';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.locale('lt');
dayjs.extend(isBetween);

interface Props {
  headline: HeadlineWithRelatedArticles;
  size: string;
}

interface Data {
  iconList: Record<string, string>;
  contentType: {
    audio: boolean;
    awkwardQuestions: boolean;
    breakingNews: boolean;
    career: boolean;
    detector: boolean;
    detectorCategory: boolean;
    economist: boolean;
    everydayHeroes: boolean;
    exclusive: boolean;
    gallery: boolean;
    graph: boolean;
    important: boolean;
    interview: boolean;
    invest: boolean;
    liveBlog: boolean;
    premiere: boolean;
    projectSyndicate: boolean;
    reminds: boolean;
    renew: boolean;
    research: boolean;
    specialProject: boolean;
    stream?: boolean;
    streamSoon?: boolean;
    test: boolean;
    video: boolean;
    saugu: boolean;
    sauguComment: boolean;
    regionNews: boolean;
    dakaras: boolean;
    weekReview: boolean;
    paid?: boolean;
  };
}

interface Computed {
  isMobileView: boolean;
  isStream: boolean;
  isStreamDvr: boolean;
  isStreamSoon: boolean;
  absoluteIcons: any;
  flexIcons: any;
  definedLabels: Label[];
}

type VideoStreamDateRange = {
  start: string;
  end: string;
};

interface Methods {
  hasIcon: (icon: string) => boolean;
  hasTagId: (tagId: number) => boolean;
  isPrimaryCategory: (categoryId: number) => boolean;
  getClassModifier: (name: string) => string[];
  getLabelClassModifier: (label: Record<string, any>) => string[];
  getVideoStreamDateRange: () => VideoStreamDateRange | null;
  weightIcons: (icons: string[]) => string[];
}

interface Process {
  client: boolean;
}

declare let process: Process;

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    BaseIcon,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  data() {
    return {
      iconList,
      contentType: {
        audio:
          this.headline.relatedEntities?.hasAudio || !!this.headline.settings?.find((setting) => setting.key === 'frontPageAudio' && setting.value === true),
        awkwardQuestions:
          !!this.headline.sources?.items?.find((source) => source.id === 96207701) ||
          (this.headline.settings?.find((setting) => setting.key === 'sources')?.value.length &&
            this.headline.settings?.find((setting) => setting.key === 'sources')?.value[0]['name'] === 'Nepatogūs klausimai'),
        breakingNews: !!this.headline.settings?.find((setting) => setting.key === 'frontPageBreakingNews' && setting.value === true),
        career:
          !!this.headline.tags?.items?.find((tag) => careerTags.includes(tag.id)) ||
          !!this.headline.settings?.find((setting) => careerIcons.includes(setting.key) && setting.value === true),
        detector: this.headline.primaryCategory?.parentCategory?.id === 85827763 || this.headline.primaryCategory?.parentCategory?.id === 79440681,
        detectorCategory: detectorCategories.includes(this.headline.primaryCategory?.id),
        economist:
          !!this.headline.tags?.items?.find((tag) => tag.id === 49711978) ||
          !!this.headline.sources?.items?.find((source) => source.id === 82072961) ||
          (this.headline.settings?.find((setting) => setting.key === 'sources')?.value.length &&
            this.headline.settings?.find((setting) => setting.key === 'sources')?.value[0]['name'] === 'The Economist'),
        everydayHeroes:
          !!this.headline.sources?.items?.find((source) => source.id === 96207705) ||
          (this.headline.settings?.find((setting) => setting.key === 'sources')?.value.length &&
            this.headline.settings?.find((setting) => setting.key === 'sources')?.value[0]['name'] === 'Kasdienybės herojai'),
        exclusive:
          (this.headline.settings?.find((setting) => setting.key === 'icon.exclusive')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageImportant' && setting.value === true),
        gallery:
          this.headline.relatedEntities?.hasGallery ||
          (this.headline.settings?.find((setting) => setting.key === 'icon.image')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageImage' && setting.value === true),
        graph:
          (this.headline.settings?.find((setting) => setting.key === 'icon.graph')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageGraph' && setting.value === true),
        important: this.headline.settings?.find((setting) => setting.key === 'icon.important')?.value ?? false,
        interview: !!this.headline.settings?.find((setting) => setting.key === 'frontPageInterview' && setting.value === true),
        invest:
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageInvest' && setting.value === true) ||
          !!this.headline.sources?.items?.find((source) => source.id === 13162143) ||
          (this.headline.settings?.find((setting) => setting.key === 'sources')?.value.length &&
            this.headline.settings?.find((setting) => setting.key === 'sources')?.value[0]['name'] === 'Žurnalas „Investuok"'),
        liveBlog: !!this.headline.settings?.find((setting) => setting.key === 'articleLiveBlog' && setting.value === true),
        projectSyndicate:
          !!this.headline.sources?.items?.find((source) => source.id === 92312633) ||
          (this.headline.settings?.find((setting) => setting.key === 'sources')?.value.length &&
            this.headline.settings?.find((setting) => setting.key === 'sources')?.value[0]['name'] === 'Project Syndicate'),
        premiere:
          !!this.headline.settings?.find((setting) => setting.key === 'frontPagePremiere' && setting.value === true) ||
          !!(
            this.headline.content.paywall?.enabled &&
            this.headline.content.paywall.disableAt &&
            new Date() < new Date(this.headline.content.paywall.disableAt)
          ),
        reminds: !!this.headline.settings?.find((setting) => setting.key === 'frontPageDelfiReminds' && setting.value === true),
        renew:
          (this.headline.settings?.find((setting) => setting.key === 'icon.renewed')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageRenewed' && setting.value === true),
        research:
          (this.headline.settings?.find((setting) => setting.key === 'icon.research')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageResearch' && setting.value === true) ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageInvestigativeJournalism' && setting.value === true),
        specialProject:
          (this.headline.settings?.find((setting) => setting.key === 'icon.spec_project')?.value ?? false) ||
          !!this.headline.settings?.find((setting) => setting.key === 'specialProject' && setting.value === true),
        test: !!this.headline.settings?.find((setting) => setting.key === 'frontPageTest' && setting.value === true),
        video:
          ((this.headline.settings?.find((setting) => setting.key === 'icon.video')?.value ?? false) &&
            this.headline.primaryCategory?.channel.url !== 'www.delfi.lt/tv') ||
          (this.headline.relatedEntities?.hasVideo && this.headline.primaryCategory?.channel.url !== 'www.delfi.lt/tv') ||
          !!this.headline.settings?.find((setting) => setting.key === 'frontPageVideo' && setting.value === true),
        saugu: !!this.headline.tags?.items?.find((tag) => tag.id === 96596245),
        sauguComment: !!this.headline.tags?.items?.find((tag) => tag.id === 96596571),
        regionNews: !!this.headline.tags?.items?.find((tag) => tag.id === 96604166),
        dakaras: this.headline.primaryCategory?.slug === 'dakaras',
        weekReview: !!this.headline.tags?.items?.find((tag) => tag.id === 96605139),
      },
    };
  },
  computed: {
    isMobileView() {
      if (process.client) {
        const isIpad = (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) as boolean;

        return window.screen.width <= gridConfig.breakpoints.lg || isIpad;
      } else {
        return this.$ua && (this.$ua.isFromSmartphone() || this.$ua.isFromMobilephone() || this.$ua.isFromTablet());
      }
    },
    isStream() {
      const videoStreamDateRange = this.getVideoStreamDateRange();

      const streamEventStart =
        (videoStreamDateRange && videoStreamDateRange.start) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventStart')?.value ?? false);
      const streamEventEnd =
        (videoStreamDateRange && videoStreamDateRange.end) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventEnd')?.value ?? false);

      const hasLiveAttribute =
        this.headline.settings?.find((setting: { key: string }) => setting.key === 'icon.live' || setting.key === 'frontPageLiveVideo')?.value ?? false;

      if (!streamEventStart || !streamEventEnd) {
        return false;
      }

      return dayjs().isBetween(dayjs(streamEventStart), dayjs(streamEventEnd), 's') && hasLiveAttribute;
    },
    isStreamDvr() {
      const videoStreamDateRange = this.getVideoStreamDateRange();

      const streamEventStart =
        (videoStreamDateRange && videoStreamDateRange.start) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventStart')?.value ?? false);
      const streamEventEnd =
        (videoStreamDateRange && videoStreamDateRange.end) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventEnd')?.value ?? false);

      const hasLiveAttribute =
        this.headline.settings?.find((setting: { key: string }) => setting.key === 'icon.live' || setting.key === 'frontPageLiveVideo')?.value ?? false;

      if (!streamEventStart || !streamEventEnd) {
        return false;
      }

      return dayjs().isBetween(dayjs(streamEventStart), dayjs(streamEventEnd), 's') && !hasLiveAttribute;
    },
    isStreamSoon() {
      const videoStreamDateRange = this.getVideoStreamDateRange();

      const streamEventStart =
        (videoStreamDateRange && videoStreamDateRange.start) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventStart')?.value ?? false);
      const streamEventEnd =
        (videoStreamDateRange && videoStreamDateRange.end) ||
        (this.headline.settings?.find((setting: { key: string }) => setting.key === 'streamEventEnd')?.value ?? false);

      const hasLiveAttribute =
        this.headline.settings?.find((setting: { key: string }) => setting.key === 'frontPageLiveVideo' || setting.key === 'icon.live')?.value ?? false;

      if (!streamEventStart || !streamEventEnd) {
        return false;
      }

      return dayjs().isBetween(dayjs(streamEventStart).subtract(5, 'minutes'), dayjs(streamEventStart), 's') && hasLiveAttribute;
    },
    absoluteIcons() {
      const icons: string[] = [];

      Object.entries(this.contentType).forEach(([name, isEnabled]) => {
        const icon = iconsConfig[name];

        if (icon && isEnabled && icon.position && icon.position === 'bottom') {
          icons.push(name);
        }
      });

      // Detect youtube streams
      if (this.isStream) {
        icons.push('stream');
      }

      // Detect dvideo streams
      if (this.isStreamDvr) {
        icons.push('streamDvr');
      }

      // Detect youtube streams 5min before
      if (this.isStreamSoon) {
        icons.push('streamSoon');
      }

      return this.weightIcons(icons);
    },
    flexIcons() {
      const icons: string[] = [];

      Object.entries(this.contentType).forEach(([name, isEnabled]) => {
        const icon = iconsConfig[name];

        if (icon && isEnabled && icon.position && (icon.position === 'right' || icon.position === 'left')) {
          icons.push(name);
        }
      });

      if (this.headline.content.paywall?.enabled && this.$store?.state?.piano?.access?.channelAccess) {
        icons.push('paid');
      }

      return icons;
    },
    definedLabels() {
      const definedLabels = getDefinedLabels(this.headline, 'image');
      return definedLabels;
    },
  },
  methods: {
    hasIcon(icon) {
      return !!this.headline.settings?.find((setting) => setting.key === icon && setting.value === true);
    },
    hasTagId(tagId) {
      return !!this.headline.tags?.items?.find((tag) => tag.id === tagId);
    },
    isPrimaryCategory(categoryId) {
      return this.headline.primaryCategory?.id === categoryId;
    },
    getClassModifier(name) {
      const modifiers: string[] = [];

      const icon = iconsConfig[name];
      if (icon) {
        if (icon.type && icon.type !== 'default') {
          modifiers.push(`headline-icons__icon--${icon.type}`);
        }

        if (icon.position && icon.position !== 'right') {
          modifiers.push(`headline-icons__icon--${icon.position}`);
        }

        if (icon.fa) {
          modifiers.push(`headline-icons__icon--fa`);
        }

        if (icon.color) {
          modifiers.push(`headline-icons__icon--${icon.color}`);
        }
      }

      modifiers.push(`headline-icons__icon--${name}`);

      return modifiers;
    },
    getLabelClassModifier(label) {
      const modifiers: string[] = [];

      if (label) {
        if (label.fa) {
          modifiers.push(`headline-icons__icon--fa`);
        }

        if (label.position) {
          modifiers.push(`headline-icons__icon--${label.position}`);
        }

        if (label.type) {
          modifiers.push(`headline-icons__icon--${label.type}`);
        } else {
          modifiers.push(`headline-icons__icon--default`);
        }

        if (label.color) {
          modifiers.push(`headline-icons__icon--${label.color}`);
        }
        if (label.class) {
          modifiers.push(`headline-icons__icon--${label.class}`);
        }

        if (label.text) {
          modifiers.push(`headline-icons__icon--text-thin`);
        }

        if (label.text && label.image) {
          modifiers.push(`headline-icons__icon--flex`);
        }
      }

      return modifiers;
    },
    getVideoStreamDateRange() {
      let videoStreamStart: string | boolean = false;
      let videoStreamEnd: string | boolean = false;

      const videoStreamDateRange = this.headline.settings?.find((setting: { key: string }) => setting.key === 'videoStreamDateRange')?.value ?? false;
      if (videoStreamDateRange && videoStreamDateRange.length === 2) {
        videoStreamStart = dayjs(videoStreamDateRange[0], 'DD.MM.YYYY HH:mm').toISOString();
        videoStreamEnd = dayjs(videoStreamDateRange[1], 'DD.MM.YYYY HH:mm').toISOString();

        return {
          start: videoStreamStart,
          end: videoStreamEnd,
        };
      }

      return null;
    },
    weightIcons(icons: string[]) {
      const weightedIcons = icons
        .map((icon) => {
          return { ...iconsConfig[icon], name: icon };
        })
        .sort((a, b) => a.weight - b.weight);

      return weightedIcons.length ? [weightedIcons[0].name] : [];
    },
  },
});
</script>
<style lang="scss">
.headline-icons {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;

  &__wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 8px;
    justify-content: flex-end;

    &--absolute {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0;

      .headline-icons__icon--left {
        top: 8px;
      }
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    border-radius: $base-radius;
    min-width: 28px;
    height: 28px;

    &:not(:last-child) {
      margin-right: 8px;
    }

    @include media-breakpoint-down(md) {
      min-width: 22px;
      height: 22px;
    }
  }

  /* Types */

  &__icon--fa {
    color: get-color('white');
    font-size: 14px;
  }

  &__icon--text {
    min-height: 30px;
    padding: 0 12px;
    font-family: get-font-family('system');
    font-size: 12px;
    font-weight: get-font-weight('bold');
    line-height: 15px;
    color: get-color('white');
    text-align: center;
    text-transform: uppercase;

    @include media-breakpoint-down(md) {
      min-height: 22px;
      padding: 0 6px;
      font-size: 10px;
      line-height: 13px;
    }

    &-thin {
      padding: 5px 11px !important;
      font-weight: 400;

      @include media-breakpoint-down(md) {
        font-size: 11px;
        padding: 3px 7px !important;
      }
    }
  }

  /* Positions */

  &__icon--bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: flex-end;
    height: 40px;
    margin: auto !important;
    background: transparent;
    border-radius: 0;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    span {
      position: relative;
      z-index: 100;
      margin-bottom: 5px;
    }
  }

  &__icon--left {
    position: absolute;
    left: 8px;
    height: auto !important;
    margin: 0;
    padding: 0;
    background: transparent;
  }

  /* Colors */

  &__icon--blue {
    &:before {
      background-image: linear-gradient(180deg, rgba(255, 222, 192, 0) 0%, rgba(56, 88, 245, 1) 100%);
    }
  }

  &__icon--dark-blue {
    &:before {
      background-image: linear-gradient(180deg, rgba(255, 222, 192, 0) 0%, rgba(4, 4, 132, 1) 100%);
    }
  }

  &__icon--dark-gray {
    color: #fff;

    &:before {
      background-image: linear-gradient(180deg, rgba(255, 222, 192, 0) 0%, rgba(83, 109, 91, 1) 100%);
    }
  }

  &__icon--gray {
    color: #000;

    &:before {
      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(244, 241, 238, 1) 100%);
    }
  }

  &__icon--red {
    &:before {
      background-image: linear-gradient(180deg, rgba(255, 222, 192, 0) 0%, rgba(250, 6, 81, 1) 100%);
    }
  }

  &__icon--green {
    &:before {
      background-image: linear-gradient(180deg, rgba(17, 204, 148, 0) 0%, rgb(17, 204, 148) 100%);
    }
  }

  &__icon--yellow {
    &:before {
      background-image: linear-gradient(180deg, rgba(17, 204, 148, 0) 0%, rgb(255, 190, 95) 100%);
    }
  }

  &__icon--sand {
    &:before {
      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(162, 116, 91) 100%);
    }
  }

  &__icon--tan {
    color: #000;

    &:before {
      background-image: linear-gradient(180deg, rgba(255, 222, 192, 0) 0%, rgba(255, 222, 195, 1) 100%);
    }
  }

  &__icon--flex {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
  }
  /* Misc */

  &__icon--audio svg {
    fill: get-color('white');
    stroke: get-color('white');

    @include media-breakpoint-down(md) {
      width: 10px;
      height: 10px;
    }
  }

  &__icon--video svg {
    fill: get-color('white');

    @include media-breakpoint-down(md) {
      width: 6px;
      height: 6px;
    }
  }

  &__icon--gallery svg {
    @include media-breakpoint-down(md) {
      width: 10px;
      height: 10px;
    }
  }

  &__icon--detectorCategory {
    color: #ffffff;
    background-color: rgba(250, 6, 81, 0.8);

    i {
      margin-right: 4px;
      font-size: 12px;
    }
  }

  &__icon--paid {
    background: #ffff56;
  }

  &__icon--paid svg {
    @include media-breakpoint-down(md) {
      width: 16px;
      height: 16px;
    }
  }

  &__icon--stream,
  &__icon--streamDvr,
  &__icon--streamSoon {
    display: flex;
    align-items: flex-end;
    justify-content: center;

    i {
      $live-circle-left: 1px;
      $live-circle-top: 0px;
      $live-circle-width: 16px;

      position: relative;
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      margin-bottom: 5px;
      z-index: 2;

      &:before,
      &:after {
        content: '';
        position: absolute;
        border-radius: 100px;
        animation: pulse 2s infinite;

        @include pulse-animation('pulse', #fff);
      }

      &:before {
        left: $live-circle-left;
        width: $live-circle-width;
        height: $live-circle-width;
        background: rgba(#fff, 0.3);
      }

      &:after {
        left: $live-circle-left + $live-circle-width / 4;
        top: $live-circle-top + $live-circle-width / 4;
        width: $live-circle-width / 2;
        height: $live-circle-width / 2;
        background: #fff;
      }

      @include media-breakpoint-down(md) {
        &:before,
        &:after {
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }

    span {
      margin-bottom: 6px;
    }
  }

  &__icon--economist {
    img {
      @include media-breakpoint-down(md) {
        width: 73px !important;
      }
    }
  }

  &__icon--invest {
    img {
      @include media-breakpoint-down(md) {
        width: 80px !important;
      }
    }
  }

  &__icon--projectSyndicate {
    img {
      @include media-breakpoint-down(md) {
        width: 28px !important;
      }
    }
  }

  &__icon--saugu {
    svg {
      @include media-breakpoint-down(md) {
        width: 52px !important;
      }
    }
  }

  /* Override for small blocks usage */
  &--small {
    .headline-icons__wrapper {
      padding: 4px;
    }

    .headline-icons__icon {
      &:not(:last-child) {
        margin-right: 4px;
      }

      &--text {
        padding: 0 6px;
        font-size: 10px;
      }

      &--stream,
      &--streamDvr,
      &--streamSoon {
        i {
          display: none;
        }
      }

      &--left {
        top: 4px;
        left: 4px;
      }

      @include media-breakpoint-down(md) {
        img {
          width: 80% !important;
        }

        &--bottom {
          height: 50%;
        }
      }
    }
  }
}
</style>
